import { render, staticRenderFns } from "./CreateForms - 副本.vue?vue&type=template&id=7fb9702b"
import script from "./CreateForms - 副本.vue?vue&type=script&lang=js"
export * from "./CreateForms - 副本.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports